export default "__VITE_PUBLIC_ASSET__28745909__"